import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

export default defineNuxtRouteMiddleware(async (to) => {
  const userDetailsStore = useUserDetailsStore();

  const { userName } = storeToRefs(userDetailsStore);

  // User details is used for Mixpanel events
  if (!userName.value) {
    userDetailsStore.getUserDetails();
  }
  const regex = /\d/;
  if (!regex.test(to.fullPath)) {
    const { trackEvent, eventNames } = useAcvAnalytics();
    trackEvent(eventNames.REC_PAGE_REDIRECT_NO_JOB_IDS);
    return navigateTo({ path: '/' });
  }
});
